import { render, staticRenderFns } from "./WxPay.vue?vue&type=template&id=05843c8a&scoped=true&"
import script from "./WxPay.vue?vue&type=script&lang=js&"
export * from "./WxPay.vue?vue&type=script&lang=js&"
import style0 from "./WxPay.vue?vue&type=style&index=0&id=05843c8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05843c8a",
  null
  
)

export default component.exports